import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchBlastHistory } from "../redux/notificationsSlice";
import "./AdminBlast.css";

// Admin controls → "Admin Blast History": every blast ever sent (newest first) with
// sender, timestamp and how many users have read it. Read from GET /admin/blasts.

const formatWhen = (createdAt) => {
    if (!createdAt) return "";
    const d = new Date(createdAt);
    return isNaN(d.getTime()) ? "" : d.toLocaleString();
};

const BlastHistoryModal = ({ onClose }) => {
    const dispatch = useDispatch();
    const { history, historyLoading } = useSelector((state) => state.notifications);

    useEffect(() => {
        dispatch(fetchBlastHistory());
    }, [dispatch]);

    return (
        <div className="admin-blast-overlay" onClick={onClose}>
            <div
                className="admin-blast-dialog admin-blast-dialog-wide"
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
            >
                <h3 className="admin-blast-title">Admin Blast History</h3>
                <div className="admin-blast-history">
                    {historyLoading ? (
                        <div className="admin-blast-history-empty">Loading…</div>
                    ) : history.length === 0 ? (
                        <div className="admin-blast-history-empty">No blasts sent yet.</div>
                    ) : (
                        history.map((blast) => (
                            <div className="admin-blast-history-row" key={blast.id}>
                                <div className="admin-blast-history-subject">{blast.subject}</div>
                                <div className="admin-blast-history-body">{blast.body}</div>
                                <div className="admin-blast-history-meta">
                                    <span>{blast.senderUsername}</span>
                                    <span>{formatWhen(blast.createdAt)}</span>
                                    <span>Read by {blast.readCount}</span>
                                </div>
                            </div>
                        ))
                    )}
                </div>
                <div className="admin-blast-buttons">
                    <button
                        type="button"
                        className="admin-blast-btn admin-blast-btn-cancel"
                        onClick={onClose}
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BlastHistoryModal;
